<script setup>
import KeywordManagementForm from '@frontJs/components/forms/projectManagement/sea/KeywordManagementForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, googleAdsKeywordManagement, variableInformation } = defineProps(
    {
        tenant: {
            type: Object,
            required: true,
        },
        googleAdsKeywordManagement: {
            type: Object,
            required: false,
        },
        variableInformation: {
            type: Object,
            required: true,
        },
    },
);

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="googleAdsKeywordManagement">
            Mettre à jour le pilotage search #{{
                googleAdsKeywordManagement.id
            }}
            - Pilotage Search - SEA - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un pilotage search - Pilotage Search - SEA - Gestion de projet
            - Datakepler
        </title>
    </Head>

    <PageTitle v-if="googleAdsKeywordManagement" :tenant-name="tenant.name">
        Gestion de projet - SEA - Pilotage Search - Mettre à jour le pilotage
        search #{{ googleAdsKeywordManagement.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEA - Pilotage Search - Créer un pilotage search
    </PageTitle>

    <KeywordManagementForm
        :tenant="tenant"
        :google-ads-keyword-management="googleAdsKeywordManagement"
        :variable-information="variableInformation"
    />
</template>
